module.exports = __webpack_public_path__ + "img/1618.6650808e.gif";